import { createBrowserHistory } from "history"
import { PUBLIC_PATH } from "modules/common"

export const history = createBrowserHistory({
    basename: PUBLIC_PATH,
})
